<template>
    <div v-show="!loading" class="detail">
        <span @click="backToList" class="backIcon"></span>
        <banner :bannersList="bannersList"></banner>
        <div class="textContent">
            <div ref="textBox" class="textBox">
                <div class="detailTitle">
                    <span class="textTitle">{{title}}</span>
                </div>
                <div ref="richText" class="richText"></div>
            </div>
        </div>
        <detail-audio v-if="audioSrc" :title="title" :audioUrl="audioSrc"></detail-audio>
    </div>
</template>

<script>
import detailAudio from '@/components/detailAudio.vue';
import banner from '@/components/banner.vue';
const detailData = require('@/assets/data.json');

require('@/assets/styles/detail.scss');
export default {
    data () {
        return {
            loading: false,
            title: '',
            audioSrc: '',
            bannersList: []
        }
    },
    components: {detailAudio, banner},
    mounted () {
        this.loading = true;
        this.getDetail();
    },
    methods: {
        backToList () {
            this.$router.replace({
                path: '/map'
            });
        },
        getDetail () {
            const name = this.$route.params.name;
            detailData.forEach(item => {
                if (name === item.pinyin) {
                    this.loading = false;
                    this.bannersList = item.detail_images;
                    this.title = item.name;
                    this.audioSrc = item.mp3;
                    this.$refs.richText.innerHTML = item.content;
                }
            });
        },
    }
}
</script>

